













import { Component, Prop, Vue } from "vue-property-decorator";
import { VueContext } from 'vue-context';

import * as def from "@/definitions";
@Component({
  components: {
        VueContext
    }
})
export default class ContextMenu extends Vue 
{
    // メニューアイテム
    private menuItems : Array<{ text : string, isEnable : boolean, callback : () => void }> = [];

    public open(event, menuItems)
    {
        var menu = this.$refs.menu as VueContext;
        if(menu == null) { return; }
        menu.open(event);
        this.menuItems = menuItems;
    }

    public close()
    {
        var menu = this.$refs.menu as VueContext;
        if(menu != null) menu.close();
    }

    private onClick(menuItem)
    {
        if(menuItem.isEnable)
        {
            var menu = this.$refs.menu as VueContext;
            if(menu != null)
            {
                menu.close();
            }

            menuItem.callback();
        }
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
